"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheGoldenStandardOfFreshness() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="238050" id="framtidens-logik" className="relative w-full flex items-center justify-center bg-background text-foreground overflow-hidden ![padding:80px_0px_80px_0px]">
      {}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/4 w-[800px] h-[800px] bg-primary/5 rounded-lg blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-[1280px] relative z-10">
        <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-16 md:gap-20 lg:gap-20 items-center">
          
          {}
          <div ref={textRef} className={`order-2 md:order-1 flex flex-col gap-12 transition-all duration-1000 ease-out relative before:absolute before:inset-0 before:-z-10 before:bg-[linear-gradient(135deg,#559EA0/10_0%,#0D1F41/5_100%)] before:blur-3xl ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="space-y-6">
              <h1 className="font-default font-bold leading-[1.0] tracking-tighter text-primary !text-6xl">Din långsiktiga partner för AI-driven transformation och innovation</h1>
              <p className="text-foreground font-default tracking-wide max-w-2xl !text-4xl ![padding:40px_0px_40px_0px]">Skräddarsydda egna AI- och SaaS-lösningar för e-handel, utbildning, logistik och vård. Anpassade för nordiska krav. Byggda för mätbart affärsvärde.</p>
              <p className="text-foreground font-default tracking-wide max-w-2xl !text-4xl">Från mindre företag till komplexa organisationer skapar vi mätbart affärsvärde med AI.</p>
            </div>

            <div className="flex flex-wrap items-center gap-8 pt-2">
              <div className="flex flex-col items-center gap-3">
                <Button asChild size="lg" className="h-10 text-sm inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-4 bg-[#0D1F41] text-white rounded-md font-semibold shadow-lg transition-transform !text-2xl !h-[80px] ![padding:0px_20px_0px_20px] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-[#0D1F41]/90 hover:scale-105">
                  <Link to="https://ifaaitech.com/kontakt/">Boka kostnadsfri konsultation</Link>
                </Button>
                
              </div>
              <Button variant="link" onClick={e => {
              e.preventDefault();
              document.getElementById('whatwedo')?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }} className="justify-center whitespace-nowrap rounded-md [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive underline-offset-4 has-[>svg]:px-3 text-primary font-semibold flex items-center gap-2 transition-colors h-auto p-0 !text-xl disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:underline">
                Se våra lösningar
                <ArrowRight className="size-5" />
              </Button>
            </div>
          </div>

          {}
          <div ref={imgRef} className={`order-1 md:order-2 relative transition-all duration-1000 delay-300 ease-out ${imgVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
            <div className="relative w-full max-w-[520px] mx-auto aspect-square flex items-center justify-center">
              {}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-[linear-gradient(135deg,#559EA0/10_0%,#0D1F41/5_100%)] rounded-lg blur-3xl mix-blend-multiply pointer-events-none" />
              
              <img src="https://ifaaitech.com/wp-content/uploads/2026/05/IFA-AI-TECH-LOGIC-HEM.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654999/img/nordic_tech_neural_abstract.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654999/img/nordic_tech_neural_abstract.png-wvc-sizes" alt="Minimalistisk 3D-rendering av ett neuralt nätverk i glas" className="object-contain relative z-10 drop-shadow-xl !w-[591.982px]" loading="lazy" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}